// Where the quota screens live in the shell they are mounted in (NAV-019, ADR-101). The AllCode
// admin keeps an org's quotas under its customer (`/customers/:orgId/quotas[/:quotaId]`); the
// proxy's Admin area mounts the same screens under its base path for the session's own org
// (`/admin/quotas[/:quotaId]`). The host, not the surface, decides: an org admin in the AllCode
// admin is the customer surface, yet its pages are that app's customer routes.
import type { Host } from "../../host/host";

/** The host fields the hrefs read; `OrgHost` (api/org-context) and `Host` (host/host) both carry them. */
export type HrefHost = Pick<Host, "kind"> & Partial<Pick<Host, "basePath">>;

const CUSTOMERS = "/customers";
const QUOTAS = "/quotas";

function segment(value: string): string {
  return `/${encodeURIComponent(value)}`;
}

/**
 * The quotas list. Under the AllCode admin `orgId` is the customer in the path and is required
 * (a missing one is a programming error, never a path to `/customers//quotas`); under the proxy's
 * Admin area the org is the session's and the path carries none.
 */
export function quotasHref(host: HrefHost, orgId?: string): string {
  const base = host.basePath ?? "";
  if (host.kind !== "allcode-admin") return `${base}${QUOTAS}`;
  if (!orgId) throw new Error("quotasHref: the AllCode admin's quota paths name the customer");
  return `${base}${CUSTOMERS}${segment(orgId)}${QUOTAS}`;
}

/** One quota's own page (SCR-231), under the list of its host. */
export function quotaHref(host: HrefHost, orgId: string | undefined, quotaId: string): string {
  return `${quotasHref(host, orgId)}${segment(quotaId)}`;
}
